import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { devicesApi } from '@/api/endpoints/devices';
import { positionsApi } from '@/api/endpoints/positions';
import { useFleetStore } from '@/stores/fleet';

/**
 * Carga inicial: busca todos os dispositivos e suas últimas posições e
 * popula o store. As atualizações em tempo real vêm pelo WebSocket
 * (ver useTraccarSocket). Este hook é o que monta a frota; chame uma vez
 * no layout autenticado.
 */
export function useFleet() {
  const setDevices = useFleetStore((s) => s.setDevices);
  const setPositions = useFleetStore((s) => s.setPositions);

  const devicesQuery = useQuery({
    queryKey: ['devices'],
    queryFn: () => devicesApi.list(),
  });

  const positionsQuery = useQuery({
    queryKey: ['positions'],
    queryFn: () => positionsApi.list(),
    refetchInterval: 60_000, // fallback se o socket cair
  });

  useEffect(() => {
    if (devicesQuery.data) setDevices(devicesQuery.data);
  }, [devicesQuery.data, setDevices]);

  useEffect(() => {
    if (positionsQuery.data) setPositions(positionsQuery.data);
  }, [positionsQuery.data, setPositions]);

  return {
    isLoading: devicesQuery.isLoading || positionsQuery.isLoading,
    error: devicesQuery.error ?? positionsQuery.error,
  };
}
